import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { ProductLoaderService } from '../../services/product-loader/product-loader.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var ProductLoaderComponent = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @param {ProductLoaderService}  productLoaderService  Injectable productLoaderService service.
     */
    function ProductLoaderComponent(productLoaderService) {
        this.productLoaderService = productLoaderService;
        /**
         * Declaración del estado para mostrar el componente
         *
         * *Declaration for component loading*
         *
         * @access              private
         * @type                {boolean}
         */
        this.show = false;
        /**
         * Declaración del mensaje de muestra del componente
         *
         * *Declaration for component message*
         *
         * @access              private
         * @type                {string}
         */
        this.msg = '';
        this.currentValueLoad = 0;
        this.timer = 0;
        this.percentValue = 0;
        /**
         * Flag que nos permite activar el contador de porcentage
         *
         * *Flag that allows us to activate the percentage countere*
         *
         * @access              private
         * @type                {boolean}
         */
        this.activePer = false;
        /**
         * Declaración del porcentage del proceso de muestra del componente
         *
         * *Declaration of the percentage of the component sample process*
         *
         * @access              private
         * @type                {number}
         */
        this.percentage = 0;
    }
    /**
     * Función de Angular ejecutada una vez el componente sea cargado, subscripción al servicion
     *
     * *Angular function that is run when the component is loaded, service subscription*
     */
    ProductLoaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.productLoaderService.loaderState
            .subscribe(function (state) {
            _this.show = state.show;
            _this.msg = state.msg;
            _this.timer = state.timer ? state.timer : 5000;
            if (!_this.show) {
                return;
            }
            _this.percentValue = 0;
            var seg = _this.timer / 1000;
            setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var index;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            index = 0;
                            _a.label = 1;
                        case 1:
                            if (!(index < seg)) return [3 /*break*/, 4];
                            return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, 1000); })];
                        case 2:
                            _a.sent();
                            this.currentValueLoad += 1000;
                            this.percentValue = Math.trunc((this.currentValueLoad / this.timer) * 100);
                            _a.label = 3;
                        case 3:
                            index++;
                            return [3 /*break*/, 1];
                        case 4:
                            this.currentValueLoad = 0;
                            return [2 /*return*/];
                    }
                });
            }); }, 100);
        });
    };
    /**
     * Función de Angular ejecutada una vez el componente sea destruido, dessubscripción al servicion
     *
     * *Angular function that is run when the component is destroyed, service unsubscription*
     */
    ProductLoaderComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ProductLoaderComponent;
}());
export { ProductLoaderComponent };
